import { adminT } from '@/i18n/adminCommon'

export const ELASTICSEARCH_MESSAGES = {
  de: {
    title: 'Elasticsearch',
    intro:
      'Status, Mapping-Rotation und Index-Aufräumen für das DWH-Search-Cluster.',

    statusOnline: 'Online',
    statusOffline: 'Offline / Fehler',
    clusterLocal: 'Local',
    clusterStage: 'Stage',
    clusterProd: 'Prod',
    clusterCustom: 'Custom',
    clusterUnknown: 'Unknown',
    refresh: 'Aktualisieren',

    warningEmptyTitle:
      'Alias/Index fehlt (z. B. award). Cluster ist leer oder Aliase fehlen.',
    warningEmptyBody:
      'Lokales Docker-ES ist oft leer. Stage-/Prod-Indizes siehst du unter stage.ffdwh.de / ffdwh.de (IAM dort hat ES-Zugriff).',
    warningForbiddenTitle: 'Kein Zugriff auf dieses Elasticsearch',
    warningForbiddenBody:
      'Die lokalen AWS-Credentials dürfen dieses OpenSearch nicht lesen (es:ESHttp*). Für Stage die Admin-UI auf stage.ffdwh.de nutzen.',

    kpiAwards: 'Awards',
    kpiReleases: 'Releases',
    kpiDynamicFields: 'Dynamic fields',
    kpiSyncQueued: 'Sync queued',
    kpiBroken: 'Broken',
    kpiDocsHint: 'Dokumente im Alias',
    kpiBrokenHint: 'Mapping prüfen',
    kpiBrokenOk: 'Alles in Ordnung',
    kpiSyncHint: 'Warten auf Upsync',

    mappingTitle: 'Mapping aktualisieren',
    mappingIntro:
      'Erstellt neue Indizes mit aktuellem Mapping, reindexiert asynchron und tauscht Aliase.',
    mappingKeepOpen: 'Tab offen lassen bis 100 % / Done.',
    mappingUpdate: 'Update Mapping',
    mappingStarting: 'Starting…',
    mappingReindexRunning: 'Reindex läuft… {index}',
    mappingFinalizing: 'Aliase werden finalisiert…',
    mappingDone: 'Fertig (100 %). Neue Indizes: {indices}',
    mappingFailed: 'Fehlgeschlagen: {error}',
    mappingReindexError:
      'Reindex-Fehler — Orphans in der Indizes-Tabelle prüfen und löschen.',
    mappingProgressLabel: 'Gesamtfortschritt',
    mappingWaitingEs: 'warte auf ES…',
    mappingFinished: 'fertig',
    mappingDocs: '{done} / {total} docs',

    indicesTitle: 'Indizes',
    indicesIntro:
      'Live = Alias aktiv. Orphan = kein Alias. Broken = Mapping fehlt/falsch (z. B. contact.location kein geo_point). Liste kommt vom konfigurierten ELASTICSEARCH_HOST.',
    indicesPanelTitle: 'Cluster-Indizes',
    indicesOrphanCount: '{n} Orphan',
    indicesOrphanCountPlural: '{n} Orphans',
    indicesBrokenCount: '{n} Broken',
    indicesLoading: 'Lade Indizes…',
    indicesEmptyTitle: 'Keine Indizes',
    indicesEmpty: 'Cluster leer oder nicht erreichbar.',
    colIndex: 'Index',
    colStatus: 'Status',
    colAliases: 'Aliases',
    colDocs: 'Docs',
    colSize: 'Size',
    colMapping: 'Mapping',
    colAction: 'Aktion',
    statusLive: 'Live',
    statusOrphan: 'Orphan',
    statusBroken: 'Broken',
    statusOther: 'other',
    mappingOk: 'OK',
    protected: 'geschützt',
    delete: 'Löschen',

    deleteConfirmTitle: 'Index löschen?',
    deleteConfirmLead: 'Orphan-Index ohne Live-Alias wird entfernt:',
    deleteConfirmHint:
      'Live-Indizes mit Alias award / releases / dynamic_fields sind geschützt.',
    deleteConfirm: 'Endgültig löschen',
    deleteFailed: 'Löschen fehlgeschlagen: {error}',

    syncTitle: 'Sync & Blocked',
    syncIntro:
      'Warteschlange für den nächsten ES-Upsync und Entitäten, die wegen eines Datenfehlers nicht synchronisiert werden können.',
    syncQueueTitle: 'Sync-Warteschlange',
    syncQueueEmpty: 'Keine Einträge in der Warteschlange.',
    syncTotal: 'Total',
    blockReasonsTitle: 'Nicht sync-fähig',
    blockReasonsHintWaiting:
      '"Wartend" zählt Einträge, die noch in der Warteschlange stehen und bei jedem Lauf erneut geprüft werden.',
    blockReasonsHintTotal:
      '"Total" zählt zusätzlich bereits blockierte, aus der Warteschlange entfernte Einträge — reparierbare Fälle in der Liste darunter.',
    blockReasonsHintAria: 'Zähler erklären',
    blockReasonQueuedLabel: 'Wartend',
    blockReasonsHelpAria: 'Blockierungsgründe erklären',
    blockReasonsHelp_no_awards: 'Account/Contact ohne verknüpfte Awards',
    blockReasonsHelp_no_awardee: 'Award ohne Account/Contact',
    blockReasonsHelp_invalid_period: 'ungültiger Zeitraum',
    blockReasonsHelp_es_write_failed: 'ES-Schreibvorgang fehlgeschlagen',
    blockReasonsHelp_not_approved: 'Entität noch nicht freigegeben',
    blockReasonsHelp_excluded_by_editor: 'von Redakteur ausgeschlossen',
    blockReasonsHelp_pending_changes: 'offene, unverifizierte Changes',
    blockReasonsHelp_no_release: 'kein passendes Release',
    blockReasonsHelp_excluded_toplist: 'ausgeschlossene Topliste',
    reason_no_awards: 'Kein Award',
    reason_no_awards_desc: 'Account/Contact ist für ES-Sync markiert, hat aber keinen einzigen Award.',
    reason_no_awardee: 'Kein Awardee',
    reason_no_awardee_desc: 'Award ist für ES-Sync markiert, hat aber keinen Account/Contact zugeordnet.',
    reason_invalid_period: 'Ungültige Periode',
    reason_invalid_period_desc: 'Die Periode des Awards ist keine gültige Jahreszahl und nicht "ONGOING" (z. B. "2021-MINQ").',
    reason_es_write_failed: 'ES-Schreibfehler',
    reason_es_write_failed_desc: 'Der letzte Schreibversuch an Elasticsearch ist fehlgeschlagen. Wird beim nächsten Lauf erneut versucht.',
    reason_not_approved: 'Nicht freigegeben',
    reason_not_approved_desc: 'Entität ist noch nicht freigegeben (is_approved = false) und wird deshalb übersprungen.',
    reason_excluded_by_editor: 'Editor-Ausschluss',
    reason_excluded_by_editor_desc: 'Entität wurde von einem Redakteur explizit von der Synchronisation ausgeschlossen.',
    reason_pending_changes: 'Offene Changes',
    reason_pending_changes_desc: 'Entität hat noch nicht verifizierte/akzeptierte Changes und wird deshalb übersprungen.',
    reason_no_release: 'Kein Release',
    reason_no_release_desc: 'Es existiert noch kein passendes Release für Ranking-Gruppe + Periode dieses Awards.',
    reason_excluded_toplist: 'Toplisten-Ausschluss',
    reason_excluded_toplist_desc: 'Award gehört zu einer explizit ausgeschlossenen Topliste (z. B. "Nationale Liste (komplett)").',
    blockedReload: 'Liste neu laden',
    unblockAll: 'Unblock All',
    unblockAllConfirmTitle: 'Unblock all?',
    unblockAllConfirmBody:
      'Entfernt die Blockierung für alle gelisteten Entitäten.',
    clearAllSyncRequests: 'Alle Sync-Requests löschen',
    clearAllSyncConfirmTitle: 'Sync-Requests löschen?',
    clearAllSyncConfirmBody:
      'Entfernt elastic_sync_requested für alle gelisteten Entitäten, ohne sie erneut einzureihen.',
    blockedTitle: 'Blockierte Entitäten',
    blockedFilterLabel: 'Grund filtern',
    blockedFilterAll: 'Alle Gründe',
    blockedFilterEmpty: 'Keine Entität passt zu diesem Grund.',
    blockedCount: '{n} Einträge',
    blockedTruncated: 'nur die neuesten {n} werden angezeigt',
    blockedLoading: 'Lade…',
    blockedEmptyTitle: 'Keine betroffenen Entitäten',
    blockedEmpty: 'Keine Entität wird wegen eines Datenfehlers von der Synchronisation ausgeschlossen.',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {page} von {count}',
    colType: 'Typ',
    colId: 'ID',
    toggleIdAria: 'Vollständige ID anzeigen',
    colReason: 'Grund',
    colShortCode: 'short_code',
    colBlockedAt: 'blocked_at',
    colSyncRequested: 'elastic_sync_requested',
    unblock: 'Unblock',
    clearSyncRequest: 'Sync-Request löschen',
    unblockedEntities: 'Entsperrte Entitäten: {n}',
    clearedSyncRequests: 'Gelöschte Sync-Requests: {n}'
  },
  en: {
    title: 'Elasticsearch',
    intro:
      'Status, mapping rotation, and index cleanup for the DWH search cluster.',

    statusOnline: 'Online',
    statusOffline: 'Offline / error',
    clusterLocal: 'Local',
    clusterStage: 'Stage',
    clusterProd: 'Prod',
    clusterCustom: 'Custom',
    clusterUnknown: 'Unknown',
    refresh: 'Refresh',

    warningEmptyTitle:
      'Alias/index missing (e.g. award). Cluster is empty or aliases are missing.',
    warningEmptyBody:
      'Local Docker ES is often empty. View stage/prod indices on stage.ffdwh.de / ffdwh.de (IAM there has ES access).',
    warningForbiddenTitle: 'No access to this Elasticsearch',
    warningForbiddenBody:
      'Local AWS credentials are not allowed to read this OpenSearch (es:ESHttp*). Use the admin UI on stage.ffdwh.de for stage.',

    kpiAwards: 'Awards',
    kpiReleases: 'Releases',
    kpiDynamicFields: 'Dynamic fields',
    kpiSyncQueued: 'Sync queued',
    kpiBroken: 'Broken',
    kpiDocsHint: 'Documents in alias',
    kpiBrokenHint: 'Check mapping',
    kpiBrokenOk: 'All clear',
    kpiSyncHint: 'Waiting for upsync',

    mappingTitle: 'Update mapping',
    mappingIntro:
      'Creates new indices with the current mapping, reindexes asynchronously, and swaps aliases.',
    mappingKeepOpen: 'Keep this tab open until 100% / Done.',
    mappingUpdate: 'Update Mapping',
    mappingStarting: 'Starting…',
    mappingReindexRunning: 'Reindex running… {index}',
    mappingFinalizing: 'Finalizing aliases…',
    mappingDone: 'Done (100%). New indices: {indices}',
    mappingFailed: 'Failed: {error}',
    mappingReindexError:
      'Reindex error — check Orphans in the indices table and delete them.',
    mappingProgressLabel: 'Overall progress',
    mappingWaitingEs: 'waiting for ES…',
    mappingFinished: 'done',
    mappingDocs: '{done} / {total} docs',

    indicesTitle: 'Indices',
    indicesIntro:
      'Live = alias active. Orphan = no alias. Broken = mapping missing/wrong (e.g. contact.location not geo_point). List comes from the configured ELASTICSEARCH_HOST.',
    indicesPanelTitle: 'Cluster indices',
    indicesOrphanCount: '{n} orphan',
    indicesOrphanCountPlural: '{n} orphans',
    indicesBrokenCount: '{n} broken',
    indicesLoading: 'Loading indices…',
    indicesEmptyTitle: 'No indices',
    indicesEmpty: 'Cluster is empty or unreachable.',
    colIndex: 'Index',
    colStatus: 'Status',
    colAliases: 'Aliases',
    colDocs: 'Docs',
    colSize: 'Size',
    colMapping: 'Mapping',
    colAction: 'Action',
    statusLive: 'Live',
    statusOrphan: 'Orphan',
    statusBroken: 'Broken',
    statusOther: 'other',
    mappingOk: 'OK',
    protected: 'protected',
    delete: 'Delete',

    deleteConfirmTitle: 'Delete index?',
    deleteConfirmLead: 'Orphan index without a live alias will be removed:',
    deleteConfirmHint:
      'Live indices with alias award / releases / dynamic_fields are protected.',
    deleteConfirm: 'Delete permanently',
    deleteFailed: 'Delete failed: {error}',

    syncTitle: 'Sync & blocked',
    syncIntro:
      'Queue for the next ES upsync, plus entities that cannot be synced because of a data defect.',
    syncQueueTitle: 'Sync queue',
    syncQueueEmpty: 'Nothing in the queue.',
    syncTotal: 'Total',
    blockReasonsTitle: 'Not syncable',
    blockReasonsHintWaiting:
      '"Waiting" counts entries still sitting in the queue, rechecked on every run.',
    blockReasonsHintTotal:
      '"Total" additionally counts entries already blocked and removed from the queue — repairable cases appear in the list below.',
    blockReasonsHintAria: 'Explain counters',
    blockReasonQueuedLabel: 'Waiting',
    blockReasonsHelpAria: 'Explain block reasons',
    blockReasonsHelp_no_awards: 'account/contact without linked awards',
    blockReasonsHelp_no_awardee: 'award without account/contact',
    blockReasonsHelp_invalid_period: 'invalid period',
    blockReasonsHelp_es_write_failed: 'ES write failed',
    blockReasonsHelp_not_approved: 'entity not yet approved',
    blockReasonsHelp_excluded_by_editor: 'excluded by an editor',
    blockReasonsHelp_pending_changes: 'unverified pending changes',
    blockReasonsHelp_no_release: 'no matching release',
    blockReasonsHelp_excluded_toplist: 'excluded toplist',
    reason_no_awards: 'No award',
    reason_no_awards_desc: 'Account/contact is marked for ES sync but has no award at all.',
    reason_no_awardee: 'No awardee',
    reason_no_awardee_desc: 'Award is marked for ES sync but has no account/contact assigned.',
    reason_invalid_period: 'Invalid period',
    reason_invalid_period_desc: 'The award\'s period is not a valid year and not "ONGOING" (e.g. "2021-MINQ").',
    reason_es_write_failed: 'ES write failed',
    reason_es_write_failed_desc: 'The last write attempt to Elasticsearch failed. Retried on the next run.',
    reason_not_approved: 'Not approved',
    reason_not_approved_desc: 'Entity is not yet approved (is_approved = false) and is therefore skipped.',
    reason_excluded_by_editor: 'Excluded by editor',
    reason_excluded_by_editor_desc: 'Entity was explicitly excluded from sync by an editor.',
    reason_pending_changes: 'Pending changes',
    reason_pending_changes_desc: 'Entity has unverified/unaccepted changes and is therefore skipped.',
    reason_no_release: 'No release',
    reason_no_release_desc: 'No matching release exists yet for this award\'s ranking group + period.',
    reason_excluded_toplist: 'Excluded toplist',
    reason_excluded_toplist_desc: 'Award belongs to an explicitly excluded toplist (e.g. "Nationale Liste (komplett)").',
    blockedReload: 'Reload list',
    unblockAll: 'Unblock All',
    unblockAllConfirmTitle: 'Unblock all?',
    unblockAllConfirmBody:
      'Removes the block for every listed entity.',
    clearAllSyncRequests: 'Clear all sync requests',
    clearAllSyncConfirmTitle: 'Clear sync requests?',
    clearAllSyncConfirmBody:
      'Clears elastic_sync_requested for every listed entity, without re-queueing them.',
    blockedTitle: 'Blocked entities',
    blockedFilterLabel: 'Filter by reason',
    blockedFilterAll: 'All reasons',
    blockedFilterEmpty: 'No entity matches this reason.',
    blockedCount: '{n} entries',
    blockedTruncated: 'showing the newest {n} only',
    blockedLoading: 'Loading…',
    blockedEmptyTitle: 'No affected entities',
    blockedEmpty: 'No entity is held back from syncing by a data defect.',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {page} of {count}',
    colType: 'Type',
    colId: 'ID',
    toggleIdAria: 'Show full ID',
    colReason: 'Reason',
    colShortCode: 'short_code',
    colBlockedAt: 'blocked_at',
    colSyncRequested: 'elastic_sync_requested',
    unblock: 'Unblock',
    clearSyncRequest: 'Clear sync request',
    unblockedEntities: 'Unblocked entities: {n}',
    clearedSyncRequests: 'Cleared sync requests: {n}'
  }
}

export function elasticsearchT (lang, key, vars) {
  let text = adminT(ELASTICSEARCH_MESSAGES, lang, key)
  if (vars && typeof vars === 'object') {
    Object.keys(vars).forEach((name) => {
      text = String(text).split('{' + name + '}').join(String(vars[name]))
    })
  }
  return text
}
